// Profile/settings layout — chrome lives in <AppShell>.
import AppShell from './AppShell';

export default function ProfileLayout() {
  return <AppShell />;
}
